module.exports = __webpack_public_path__ + "img/text_bg.a436db7e.png";